<template src="./index.html">
</template>
<script>
	import config from '../../../../../../../configHttp.js';
	import { getdata } from './data.js';
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headData: getdata().headData,
				headDatas: getdata().headDatas,
				headDatasv:getdata().headDatasv,
				headDatasvi:getdata().headDatasvi,
				headDatasvii:getdata().headDatasvii,
				radios:'',
				radio:'',
				company:config.company,
				delCells:[],
			};
		},
		props: {
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			showpz: { 
				type: Boolean,
				default: false
			},
			tableDatasvii:{
				type: Array,
				default: [],
			},
			tableDatasvi:{
				type: Array,
				default: [],
			},
			tableDatas:{
				type: Array,
				default: [],
			},
			tableData: {
				type: Array,
				default: [],
			},
			tableDatasv:{
				type: Array,
				default: [],
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode:{
				type:String,
				default:""
			},
			type: {
				type: String,
				default: ""
			},
		},
		created() {
			this.$nextTick(()=>{
				
			})
		},
		methods: {
			changetime(e){
				if(!e.sdsA_1_x_1.cellVal || e.sdsA_1_x_1.cellVal==null){
					e.sdsA_1_x_1.cellVal = ''
				}
				this.inputblur(e.sdsA_1_x_1)
			},
			checkbox(e){
				console.log(e)
				if(e.sdsA_1_x_1.cellVal=='N'){
					e.sdsA_1_x_2.cellVal = ''
				}
			},
			inputblur(e){
				this.$emit("inputblur",e)
			},
			zcsclick(e){
				this.$emit("zcsclick",e)
			},
			forhover(table,colum,index){
				console.log(table)
				this.$emit("forhover",table,colum,index)
			},
			yjfschange(e){
				this.$emit("yjfschange",e)
			},
			changeqiylx(){
				this.$emit("changeqiylx",this.headobj)
			},
			foraddhang(txaval,index){
				let newhh=this.tableDatasv[this.tableDatasv.length-4].hanh
				this.tableDatasv.splice(parseFloat(this.tableDatasv.length-3),0,{
					hanh:(parseFloat(newhh)+0.1).toFixed(1),
					sdsA_1_x_1: {
						cellCode: "sdsA_1_"+(parseFloat(newhh)+0.1).toFixed(1)+"_1",
						cellOldVal: "",
						cellType: "",
						cellVal: "",
						map: null
					},
					sdsA_1_x_2: {
						cellCode: "sdsA_1_"+(parseFloat(newhh)+0.1).toFixed(1)+"_2",
						cellOldVal: "",
						cellType: "",
						cellVal: "",
						map: null
					}
				})
			},
			fordelete(index){
				if(this.$notemptyandnull(this.tableDatasv[index]['sdsA_1_x_1'].id)){
					this.delCells.push(JSON.parse(JSON.stringify(this.tableDatasv[index])) )
				}
				this.tableDatasv.splice(index,1)
				this.$emit('delCellsCode',this.delCells)
			},
			headercellstyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (rowIndex === 0) {
					if (columnIndex === 0) {
						this.$nextTick(() => {
							if (document.getElementsByClassName(column.id).length !== 0) {
								document
									.getElementsByClassName(column.id)[0]
									.setAttribute('colSpan', 4);
							}
						});
					}else{
						return {
							display: "none"
						};
					}
				}
			},
			headercellstyles({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (rowIndex === 0) {
					if (columnIndex === 0) {
						this.$nextTick(() => {
							if (document.getElementsByClassName(column.id).length !== 0) {
								document
									.getElementsByClassName(column.id)[0]
									.setAttribute('colSpan', 7);
							}
						});
					}else{
						return {
							display: "none"
						};
					}
					
				}
			},
			spanmethods({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				
				if (columnIndex === 1) {
					if(rowIndex === 0){
						return {
							rowspan: 1,
							colspan: 5
						};
					}else if(rowIndex === 1){
						return {
							rowspan: 1,
							colspan: 5
						};
					}else  if (rowIndex === 2) {
						return {
							rowspan: 3,
							colspan: 1
						};
					} else  if (rowIndex === 5) {
						return {
							rowspan: 1,
							colspan: 5
						};
					}else  if (rowIndex === 6) {
						return {
							rowspan: 1,
							colspan: 5
						};
					} else {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}else if(columnIndex === 2){
					if (rowIndex === 2) {
						return {
							rowspan: 3,
							colspan: 1
						};
					} else {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}else if(columnIndex === 3){
					if (rowIndex === 2) {
						return {
							rowspan: 3,
							colspan: 1
						};
					} else {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}else if(columnIndex === 4){
					if (rowIndex === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 1) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 2) {
						return {
							rowspan: 3,
							colspan: 1
						};
					} else  if (rowIndex === 5) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else  if (rowIndex === 6) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}  else {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}else if(columnIndex === 5){
					if (rowIndex === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 1) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else  if (rowIndex === 5) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else  if (rowIndex === 6) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}  else {
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				}
			},
			spanmethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 1) {
					if (rowIndex === 0) {
						return {
							rowspan: 4,
							colspan: 1
						};
					} else if(rowIndex === 4){
						return {
							rowspan: 2,
							colspan: 1
						};
					} else{
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}	
			}
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SmallScaleVAT/index.less');
</style>
